import "./Main.css";
import { NavLink, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";
import { getTranslatedText as translate } from "../../Localization/Translation";
import { useLocation } from "react-router";
import { useEffect } from "react";
import DeliveryJoinReq from "./DeliveryJoinReq/DeliveryJoinReq";
import LaundryJoinReq from "./LaundryJoinReq/LaundryJoinReq";

const mainTabClick = (newClassName) => {
  var newTab = document.querySelector(newClassName);

  Array.from(document.querySelectorAll(".main-tab")).forEach(function (val) {
    val.style.fontWeight = "normal";
  });
  newTab.style.fontWeight = "bold";
};

const Main = () => {
  const { locale } = useBetween(useSelector((state) => state.useSharedLang));
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/Navbar/JoinRequests/delivery")
      mainTabClick(".delivery-main-tab");
    else if (location.pathname === "/Navbar/JoinRequests/Laundry")
      mainTabClick(".Laundry-main-tab");
  }, []);

  return (
    <div className="main-component">
      <div className="main-navbar" dir="auto">
        <NavLink
          to="/Navbar/JoinRequests/delivery"
          className="delivery-main-tab main-tab current-main-tab nav-link-main-navbar"
          onClick={() => mainTabClick(".delivery-main-tab")}
        >
          <span>{translate("delivery-request-tab", locale)}</span>
        </NavLink>
        <NavLink
          to="/Navbar/JoinRequests/Laundry"
          className="Laundry-main-tab main-tab nav-link-main-navbar"
          onClick={() => mainTabClick(".Laundry-main-tab")}
        >
          <span>{translate("Laundry-Owner-request-tab", locale)}</span>
        </NavLink>
      </div>

      <Routes>
        <Route path="delivery/*" element={<DeliveryJoinReq />} />
        <Route path="Laundry/*" element={<LaundryJoinReq />} />
      </Routes>
    </div>
  );
};

export default Main;
